import React from 'react';
import ManageSignatories from '@pages-clean/shared/manage-signatories/manage-signatories';
import Constants from '@utils/constants';

const RAMManageSignatories = () => {
    return <ManageSignatories module={Constants.Modules.RAM} />;
};
export default RAMManageSignatories;
